module.exports = __webpack_public_path__ + "static/media/8-AskingForIt.a6554944.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/8-AskingForIt.jpg
// module id = 144
// module chunks = 0